import React, { useState } from 'react';
import './styles.scss';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TextField } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import config from '../../Config.js';

const EditTravelReferenceNumber = (props) => {
  const [refNumber, setRefNumber] = useState('');
  const [error, setError] = useState('');
  const maxChars = 11; // Character limit
  const getUpdatedLinkUrl = () => {
    const baseLink = props?.fields?.Link?.value?.href || '';
    return `${baseLink}?RequestId=${refNumber}`;
  };

  const handleLinkClick = async (e) => {
    try {
      e.preventDefault();
      if (!refNumber) {
        setError(props.t('ReferenceNumberRequired'));
        return;
      }

      const isReferenceNumberValid = await validateReferenceNumber();

      if (!isReferenceNumberValid) {
        setError(props.t('RefNumberWrongMsg'));
        return;
      }

      setError('');
      window.location.href = getUpdatedLinkUrl();
    } catch (error) {
      e.preventDefault();
      setError(props.t('NetworkError'));
      console.error('Validation failed:', error);
    }
  };

  const validateReferenceNumber = async () => {
    const endpointUrl = `${config.hostname}/api/internationalextensionLimit/GetCardExtensionTripData?RequestId=${refNumber}`;

    try {
      const response = await fetch(endpointUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      return data.StatusCode === 200;
    } catch (error) {
      console.error('Error validating reference number:', error);
      return false;
    }
  };
  const handleChange = (e) => {
    const value = e.target.value;

    // Enforce character limit
    if (value.length <= maxChars) {
        setRefNumber(value);
        setError(''); // Clear any error message
    } else {
        setError(`${props.t('Maximum')} ${maxChars} ${props.t('charactersAllowed')}.`);
    }
};

  return (
    <div className="containerCard">
      <div className="CardContianer">
        <div className="container__left">
          <span className="title">
            <Text field={props?.fields?.Title} />
          </span>
          <span className="subTitle">
            <Text field={props?.fields?.Subtitle} />
          </span>
        </div>
        <div className="container__right">
          <TextField
            className="textField"
            id="outlined-basic"
            label={props?.fields?.Label?.value || 'Reference Number'}
            variant="outlined"
            value={refNumber}
            onChange={handleChange}
            error={!!error}
            helperText={error}
          />
          <a href="#" onClick={handleLinkClick} className="button button-contained-primary">
            {props?.fields?.Link?.value?.text || 'Check Now'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(EditTravelReferenceNumber));
